import { Component } from '@angular/core';

@Component({
  selector: 'app-home-services-showcase-section',
  standalone: true,
  templateUrl: './services-showcase-section.component.html'
})
export class ServicesShowcaseSectionComponent {}
